import React from 'react'
import cx from 'classnames'
import moment from 'moment'
import { A, Div, H1, P } from '@driftt/tide-core'

import './style.css'

export const shouldNotDisplayProgress = progressData => {
  const twoDaysAgo = moment().subtract(2, 'd')

  return !progressData ||
    progressData.emailSentAt < twoDaysAgo.valueOf()
}

const HelpText = ({
  notStarted,
  allDone,
}) => {
  if (allDone)
    return <P className="email-progress-helptext"><strong>Your email send is complete!</strong> Check out these sweet metrics, or send another email</P>

  if (notStarted)
    return <P className="email-progress-helptext"><strong>Hang tight!</strong> We haven’t started sending your email yet, this progress bar will update automatically</P>

  return <P className="email-progress-helptext"><strong>We are sending your email!</strong> The report itself may not have data while we are still sending.</P>
}

export default ({
  emailSendProgress,
  onDismiss,
  dismissed,
}) => {
  if (shouldNotDisplayProgress(emailSendProgress) || dismissed)
    return null

  const calculatedPercentage = emailSendProgress.totalEnqueued === 0 ? 0 : Math.round((emailSendProgress.totalDequeued / emailSendProgress.totalEnqueued) * 100)
  const percentComplete = Math.min(100, calculatedPercentage)
  const width = `${percentComplete}%`
  const allDone = percentComplete === 100
  const notStarted = percentComplete === 0 || emailSendProgress.totalEnqueued === 0

  return (
    <Div className="email-send-progress-container">
      <Div className="email-send-progress-number-wrapper">
        <Div className="email-send-progress-bar-wrapper">
          <HelpText notStarted={notStarted} allDone={allDone} />
          <Div className="email-loading-bar-container"><Div className={cx("email-loading-gradient", { 'email-loading-gradient-complete': allDone })} style={{ width }}></Div></Div>
        </Div>
        <H1 className="email-send-progress-percentage">{percentComplete}%</H1>
      </Div>
      <Div className="email-send-progress-bottom-text-wrapper">
        {percentComplete >= 50 && <P className="email-send-progress-warning">Be aware that we send emails and record metrics separately, we might have sent the emails but not yet have report data!</P>}
        <A onClick={onDismiss} className="email-send-progress-dismiss">Dismiss</A>
      </Div>
    </Div>
  )
}
